import { FX_NODE_ENV } from 'src/configs/env.config'
const app = 'supplierEdi'
const MINIPROGRAM_ENV = {
	release: 'release',
	trial: 'trial',
	develop: 'develop'
}
// 微信小程序
const miniAppId = {
	weight: 'gh_725a3462b655'
}
const miniPath = {
	weight (type, { username, password, domain4log, shop_id, user_id, ids }) {
		const miniprogramEnv = FX_NODE_ENV === 'test' ? MINIPROGRAM_ENV.trial : MINIPROGRAM_ENV.release
		return {
			username: miniAppId[type],
			miniprogramEnv,
			path: `pages/home/home.html?app=${app}&shopId=${shop_id}&username=${username}&password=${password}&host=${domain4log}&userId=${user_id}&billId=${ids}`
		}
	}
}
const createMiniPramas = function (type) {
	return (config) => {
		return miniPath[type](type, config)
	}
}

export default {
	mini: {
		createMiniPramas
	}
}



// WEBPACK FOOTER //
// ./src/lib/weixin/src/miniProgram.js